export class ModifiersModel{
    public modifierid: number;
    public description: string;
    public code: string;
    public isactive: boolean;
}



// WEBPACK FOOTER //
// ./src/app/pages/trip-reservations/dropDownModifiers.model.ts